/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export default {
	ALERT: 430,
	DOCK: 10,
	DOCK_PARENT: 20,
	DRAG_ITEM: 460,
	DROP_AREA: 440,
	DROP_POSITION: 450,
	MENU: 5000,
	OVERLAY: 1000,
	POPOVER: 1600,
	TOOLTIP: 10000,
	WINDOW: 1200,
};
